import { Link } from 'react-router-dom';

const seoArticles = [
  {
    title: 'Come Utilizzare Itaobuy Spreadsheet: Guida Passo Passo',
    desc: 'Impara a navigare tra le 14 categorie dello spreadsheet e scopri tutti i segreti per uno shopping efficiente e veloce.',
    link: '/guida-completa#come-funziona',
    image: 'https://readdy.ai/api/search-image?query=Overhead%20view%20of%20elegant%20hands%20typing%20on%20laptop%20with%20fashion%20magazine%20and%20coffee%20cup%20on%20warm%20cream%20marble%20desk%2C%20soft%20Mediterranean%20morning%20light%20streaming%20through%20window%2C%20minimal%20editorial%20workspace%20aesthetic%2C%20terracotta%20notebook%20accent%2C%20clean%20organized%20composition&width=600&height=400&seq=seo-article-01&orientation=landscape',
    tag: 'Guida',
  },
  {
    title: 'Sicurezza Acquisti Online: La Protezione Che Meritano i Tuoi Dati',
    desc: 'Tutti i protocolli di sicurezza implementati da itaobuy spreadsheet per garantire acquisti protetti e navigazione anonima.',
    link: '/sicurezza-acquisti',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20golden%20padlock%20icon%20on%20warm%20cream%20textured%20background%20with%20soft%20shadows%2C%20minimal%20security%20concept%20photography%2C%20Mediterranean%20aesthetic%2C%20clean%20composition%20with%20subtle%20sage%20green%20plant%20accent%2C%20trustworthy%20sophisticated%20visual%20style&width=600&height=400&seq=seo-article-02&orientation=landscape',
    tag: 'Sicurezza',
  },
  {
    title: 'Confronto Categorie: Quale Scegliere per il Tuo Stile',
    desc: 'Analisi dettagliata di tutte le 14 categorie prodotto con tabelle comparative, prezzi e consigli personalizzati.',
    link: '/confronto-categorie',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20split%20screen%20comparison%20of%20different%20fashion%20items%20arranged%20on%20warm%20cream%20surface%2C%20soft%20natural%20lighting%2C%20minimal%20editorial%20product%20photography%2C%20Mediterranean%20aesthetic%2C%20clean%20organized%20layout%20with%20terracotta%20accent%20divider&width=600&height=400&seq=seo-article-03&orientation=landscape',
    tag: 'Analisi',
  },
  {
    title: 'Vantaggi dello Shopping con Itaobuy Spreadsheet nel 2026',
    desc: 'Scopri perch\u00e9 sempre pi\u00f9 italiani scelgono itaobuy sheet per i loro acquisti online: organizzazione, velocit\u00e0 e convenienza.',
    link: '/guida-completa#vantaggi',
    image: 'https://readdy.ai/api/search-image?query=Happy%20elegant%20shopping%20concept%20with%20stylish%20packaging%20boxes%20and%20tissue%20paper%20on%20warm%20cream%20surface%2C%20soft%20golden%20natural%20light%2C%20Mediterranean%20lifestyle%20photography%2C%20minimal%20clean%20composition%2C%20sophisticated%20unboxing%20aesthetic&width=600&height=400&seq=seo-article-04&orientation=landscape',
    tag: 'Vantaggi',
  },
  {
    title: 'Itaobuy Spreadsheet per Principianti: Da Dove Iniziare',
    desc: 'Sei nuovo nel mondo itaobuy? Questa guida ti accompagna dai primi passi fino a diventare un acquirente esperto.',
    link: '/guida-completa#principianti',
    image: 'https://readdy.ai/api/search-image?query=Open%20notebook%20with%20handwritten%20shopping%20tips%20and%20elegant%20pen%20on%20warm%20cream%20desk%2C%20soft%20natural%20window%20light%2C%20minimal%20Mediterranean%20workspace%20aesthetic%2C%20sage%20green%20plant%20accent%2C%20clean%20organized%20composition%20with%20beginner%20friendly%20welcoming%20vibe&width=600&height=400&seq=seo-article-05&orientation=landscape',
    tag: 'Tutorial',
  },
  {
    title: 'Errori Comuni da Evitare nello Shopping Online',
    desc: 'I 10 errori pi\u00f9 frequenti che gli acquirenti commettono e come itaobuy spreadsheet ti aiuta a evitarli facilmente.',
    link: '/guida-completa#errori',
    image: 'https://readdy.ai/api/search-image?query=Minimal%20warning%20sign%20concept%20with%20elegant%20crossed%20circle%20icon%20on%20warm%20cream%20background%2C%20soft%20natural%20lighting%2C%20Mediterranean%20aesthetic%2C%20clean%20sophisticated%20composition%20with%20subtle%20terracotta%20accent%2C%20editorial%20caution%20visual%20style&width=600&height=400&seq=seo-article-06&orientation=landscape',
    tag: 'Consigli',
  },
  {
    title: 'Le Migliori Sneakers del 2026 su Itaobuy Spreadsheet',
    desc: 'La guida definitiva alle sneakers pi\u00f9 trendy dell\u2019anno: modelli, prezzi, disponibilit\u00e0 e come trovarle nello spreadsheet.',
    link: 'https://kaspreadsheet.com/category-911-Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Single%20elegant%20designer%20sneaker%20on%20warm%20cream%20marble%20pedestal%2C%20soft%20dramatic%20side%20lighting%2C%20minimal%20luxury%20product%20photography%2C%20Mediterranean%20aesthetic%2C%20clean%20composition%20with%20subtle%20shadow%20play%2C%20high%20end%20editorial%20footwear%20visual&width=600&height=400&seq=seo-article-07&orientation=landscape',
    tag: 'Sneakers',
    external: true,
  },
  {
    title: 'Accessori Moda: Come Completare Ogni Outfit con Stile',
    desc: 'Dagli occhiali alle borse, passando per cinture e profumi: la guida completa agli accessori su itaobuy sheet.',
    link: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20flat%20lay%20of%20curated%20fashion%20accessories%20including%20sunglasses%20watch%20and%20leather%20bracelet%20on%20warm%20cream%20surface%2C%20soft%20natural%20lighting%2C%20Mediterranean%20editorial%20style%2C%20minimal%20clean%20composition%20with%20terracotta%20fabric%20accent&width=600&height=400&seq=seo-article-08&orientation=landscape',
    tag: 'Accessori',
    external: true,
  },
  {
    title: 'Tendenze Moda Autunno 2026: Cosa Comprare su Itaobuy',
    desc: 'Anteprima esclusiva delle tendenze moda per la stagione autunnale: hoodies, jackets, sets e molto altro nel nostro spreadsheet.',
    link: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Autumn%20fashion%20mood%20board%20with%20warm%20toned%20fabrics%20wool%20textures%20and%20elegant%20accessories%20on%20cream%20surface%2C%20soft%20golden%20hour%20lighting%2C%20Mediterranean%20aesthetic%2C%20rich%20terracotta%20ochre%20and%20sage%20green%20palette%2C%20editorial%20seasonal%20style%20photography&width=600&height=400&seq=seo-article-09&orientation=landscape',
    tag: 'Trend',
    external: true,
  },
];

export default function SEOArticlesSection() {
  return (
    <section className="bg-background-50 py-20 md:py-28">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="text-center mb-14 md:mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full border border-primary-300/40 text-xs font-medium text-primary-700 mb-6">
            Articoli SEO
          </span>
          <h2 className="font-heading text-4xl md:text-5xl font-bold text-foreground-950 leading-tight">
            Guide &amp; Approfondimenti
          </h2>
          <p className="font-heading text-4xl md:text-5xl text-foreground-400 font-light italic mt-1">
            Itaobuy Spreadsheet
          </p>
          <p className="text-sm text-foreground-500 mt-6 max-w-lg mx-auto">
            Esplora la nostra raccolta di articoli originali con guide, analisi e consigli per ottimizzare la tua esperienza di shopping con itaobuy spreadsheet.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {seoArticles.map((article) => (
            article.external ? (
              <a
                key={article.title}
                href={article.link}
                target="_blank"
                rel="noopener nofollow"
                className="group block bg-background-100 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-300/50 transition-all duration-300 cursor-pointer"
              >
                <div className="aspect-[3/2] w-full overflow-hidden bg-background-200/50">
                  <img
                    src={article.image}
                    alt={article.title}
                    title={article.title}
                    className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-5">
                  <span className="inline-block px-2.5 py-0.5 rounded-full bg-accent-100/60 text-xs font-medium text-accent-700 mb-3">
                    {article.tag}
                  </span>
                  <h3 className="font-heading text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors duration-200 mb-2 leading-snug">
                    {article.title}
                  </h3>
                  <p className="text-xs text-foreground-500 leading-relaxed mb-3">
                    {article.desc}
                  </p>
                  <span className="inline-flex items-center gap-1 text-xs font-medium text-primary-600 whitespace-nowrap">
                    Leggi l&apos;articolo <i className="ri-arrow-right-up-line text-xs"></i>
                  </span>
                </div>
              </a>
            ) : (
              <Link
                key={article.title}
                to={article.link}
                className="group block bg-background-100 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-300/50 transition-all duration-300 cursor-pointer"
              >
                <div className="aspect-[3/2] w-full overflow-hidden bg-background-200/50">
                  <img
                    src={article.image}
                    alt={article.title}
                    title={article.title}
                    className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-5">
                  <span className="inline-block px-2.5 py-0.5 rounded-full bg-accent-100/60 text-xs font-medium text-accent-700 mb-3">
                    {article.tag}
                  </span>
                  <h3 className="font-heading text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors duration-200 mb-2 leading-snug">
                    {article.title}
                  </h3>
                  <p className="text-xs text-foreground-500 leading-relaxed mb-3">
                    {article.desc}
                  </p>
                  <span className="inline-flex items-center gap-1 text-xs font-medium text-primary-600 whitespace-nowrap">
                    Leggi l&apos;articolo <i className="ri-arrow-right-line text-xs"></i>
                  </span>
                </div>
              </Link>
            )
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-12">
          <Link
            to="/guida-completa"
            className="inline-flex items-center gap-2 px-8 py-3 rounded-full bg-foreground-950 text-background-50 font-medium text-sm hover:bg-foreground-800 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-book-open-line text-base"></i>
            Vedi Tutti gli Articoli
          </Link>
        </div>
      </div>
    </section>
  );
}